module.exports = __webpack_public_path__ + "static/media/logo.4b97fe9d.png";